import { Flex } from '@chakra-ui/react';
import CallUsButton from '@components/interactive/CallUsButton';
import CTABox from '@components/interactive/CTABox';
import TextLink from '@components/interactive/TextLink';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { FsmColors } from 'chakra-ui/fsmTheme';

const CTAWithinPeriod = () => {
  return (
    <CTABox useModal={false}>
      <>
        <Header as="h3" color="white">
          Looks like you're in your Medicare Enrollment Period. Need help?
        </Header>
        <Body1>Talk to one of our Licensed Medicare Agents today to find the right plans for you. </Body1>
        <CallUsButton bg="white" color={FsmColors.navy} />
        <Flex justifyContent="center">
          <TextLink color="white" href={Routes.guideIntroduction} text="Or Shop Online for Plans" />
        </Flex>
      </>
    </CTABox>
  );
};

export default CTAWithinPeriod;
